// extracted by css-extract-rspack-plugin
export default {"headerWrapper":"_6d397bb1","hasTabs":"_16e3ba03","header":"_e9662b22","subheader":"_92b25626"};